import { render } from "./AvatarUploader.vue?vue&type=template&id=416aea67&ts=true"
import script from "./AvatarUploader.vue?vue&type=script&lang=ts"
export * from "./AvatarUploader.vue?vue&type=script&lang=ts"

import "./AvatarUploader.vue?vue&type=style&index=0&id=416aea67&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__